export default "__VITE_ASSET__CpPqtthC__"